import { SchoolEnrollmentDetailsAsl } from './../../../model/school-enrollment-details-asl.model';
import { EnrollmentPeriods } from './../../../../common-components/child-services/model/enrollment-periods.model';
import { Component, Inject, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ServiceDeliveryService } from '../../../service-delivery/service/service-delivery.service';
import { ServiceDeliveries } from '../../../model/service-deliveries.model';
import { CosReasons } from '../../../model/cos-reasons.model';
import { FormGroupDirective, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { County } from 'src/app/model/county';
import { Region } from 'src/app/model/region.model';
import { School, Grade } from 'src/app/model/school.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Student } from 'src/app/model/student/student.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { StudentEligibilitiesService } from '../../../service/student-eligibilities.service';
import { EditChildModalComponent } from '../../edit-child-modal-btn/edit-child-modal/edit-child-modal.component';
import Swal from 'sweetalert2';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { PartyServices } from 'src/app/component/service-administration/model/party-services.model';
import { MatTableDataSource } from '@angular/material/table';
import { ServiceHourRanges } from 'src/app/component/service-administration/model/service-hour-ranges.model';
import { GetGradeByNamePipe } from 'src/app/pipes/get-grade-object.pipe';
import { MatSort, Sort } from '@angular/material/sort';
import { EnrollmentReportStudent } from 'src/app/component/child-reports/enrollment-report/model/enrollment-report-result.model';
import { MatPaginator } from '@angular/material/paginator';
import { AgePipe } from 'src/app/pipes/age.pipe';

@Component({
    selector: 'app-edit-child-service-participation-modal',
    templateUrl: './edit-child-service-participation-modal.component.html',
    styleUrls: ['./edit-child-service-participation-modal.component.scss']
})
export class EditChildServiceParticipationModalComponent implements OnInit {
    @Input() students!: any[];
    @Input() serviceDelivery: ServiceDeliveries;
    @Input() mode: 'view' | '';
    @Input() cosMode: boolean = false;

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    title: string;
    uniqueStudents: any[] = [];
    studentLength: number = 0;

    @ViewChild('serviceParticipationForm') childInfoForm: FormGroupDirective;
    form: UntypedFormGroup;

    // Reference Data
    cosReasons: CosReasons[];
    enrollmentPeriods: EnrollmentPeriods[];
    schoolEnrollments: any[] = [];
    missingEoEStudents: Student[];

    selectedSchoolYear: string = ''; // to hold actual school year value
    selectSchoolYear: string = ''; // for initial edit
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenRegion: Region;
    chosenCounty: County;
    chosenCountyName: string;
    chosenSchoolDistrict: SchoolDistrict;
    chosenSchoolDistrictName: string;
    chosenSchool: School;
    chosenSchoolName: string;
    chosenGrades: Grade[] = [];
    chosenGrade: Grade;
    chosenSchoolEnrollment: any;
    chosenEnrollmentPeriods: EnrollmentPeriods[] = [];

    // Service Participation Data
    selectServices: PartyServices[] = [];
    chosenServices: PartyServices[] = [];
    chosenServiceHoursRequired: PartyServices[] = [];
    // Grade?
    // Service Period ?
    // Services ?

    // Date options
    maxEndOfEligibilityStudent?: Student;
    maxTerminationStudent?: Student;
    restrictedDateOptions = {
        minDate: new Date(),
        maxDate: new Date()
    };
    startDateOptions = {
        defaultMinDate: new Date(),
        defaultMaxDate: new Date(),
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    endDateOptions = {
        defaultMinDate: new Date(),
        defaultMaxDate: new Date(),
        minDate: new Date(),
        maxDate: new Date(),
        startAt: new Date()
    };
    dateFlags: any[] = [];
    creationFlags: any[] = [];
    thirdBirthdayFlag: boolean = false;
    ageRestrictedStudent: any;

    formChanges: any = {};

    // Selected Children Table
    selectedChildrenTableDataSource: MatTableDataSource<EnrollmentReportStudent>;
    selectedChildrenFilter: string = '';
    columns = {
        EDIT: { INDEX: 1, ENABLED: true, SORT: 'EDIT', DATA: 'EDIT', DISABLED: false },
        'MSD Number': { INDEX: 6, ENABLED: true, SORT: 'MSD_NUMBER', DATA: 'MSD_NUMBER', DISABLED: true },

        Name: { INDEX: 10, ENABLED: true, SORT: 'PERSON.LAST_NAME', DATA: 'PERSON.LAST_NAME', DISABLED: true },

        Grade: { INDEX: 20, ENABLED: true, SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE', DATA: 'GRADE', DISABLED: true, SCHOOL_ENROLLMENT_DETAILS: true },
        'Enroll Type': {
            INDEX: 21,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE',
            DATA: 'ENROLLMENT_TYPE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Enroll Date': {
            INDEX: 27,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE',
            DATA: 'ENROLLMENT_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        'Withdrawal Date': {
            INDEX: 28,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE',
            DATA: 'WITHDRAWAL_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        },
        EoE: {
            INDEX: 29,
            ENABLED: true,
            SORT: 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DATA: 'STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE',
            DISABLED: true,
            SCHOOL_ENROLLMENT_DETAILS: true
        }
    };
    selectedChildrenDisplayedColumns: string[] = [];

    // Table display for current changes
    displayedColumns: string[] = ['CHANGED_FIELD', 'VALUE', 'CHANGED_VALUE'];

    // Table results for current changes
    tableDataSource: MatTableDataSource<any>;

    // Component variables
    resetField: boolean = false;

    loadingSchoolEnrollments: boolean = false;
    loadingSchoolEnrollmentsTimeout: NodeJS.Timeout;
    loadingChanges: boolean = false;
    isLoading: boolean = false;
    isLoadingGroup: boolean = false;
    isSaving: boolean = false;
    isSubmitting: boolean = false;

    promises: Array<any> = [];

    msg: MsgModel;

    // Pipes
    cleanDatePipe: CleanDatePipe = new CleanDatePipe();
    simpleDatePipe: SimpleDatePipe = new SimpleDatePipe();
    getPropertyPipe: GetPropertyPipe = new GetPropertyPipe();
    getGradeByNamePipe: GetGradeByNamePipe = new GetGradeByNamePipe();
    agePipe: AgePipe = new AgePipe();
    simpleDate(date: Date) {
        return date ? this.simpleDatePipe.transform(this.cleanDatePipe.transform(date)) : '';
    }

    // Subscriptions
    subs: Subscription[] = [];

    constructor(
        public dialogRef: MatDialogRef<EditChildModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private serviceDeliveryService: ServiceDeliveryService,
        private studentEligibilitiesService: StudentEligibilitiesService
    ) {
        this.form = fb.group({
            schoolEnrollment: ['', [Validators.required]],
            enrollmentType: ['', [Validators.required]],
            startDate: ['', [Validators.required]],
            endDate: ['']
        });

        if (this.data.cosMode) {
            this.removeControl('schoolEnrollment');

            this.addControl('cosType');
        } else if (this.data.students.length > 1) {
            this.removeControl('schoolEnrollment');
        }

        this.subscriptions();
    }

    subscriptions() {
        let startDateSub = this.form.get('startDate')!.valueChanges.subscribe((changes) => {
            if (changes && this.mode != 'view') {
                this.setEndDate(changes);
            }
        });

        this.subs.push(startDateSub);

        let formSub = this.form.valueChanges.subscribe(() => {
            if (this.serviceDelivery) {
                let changes = this.form.getRawValue();
                Object.keys(changes).forEach((key) => {
                    if (this.formChanges[key]) {
                        this.formChanges[key].CHANGED_VALUE = changes[key];
                    } else if (!isNaN(parseInt(key))) {
                        // Service Hour are in IDs (number)
                        let serviceHourRange: ServiceHourRanges = changes[key];
                        if (serviceHourRange) {
                            this.formChanges['serviceHour'].CHANGED_VALUE =
                                serviceHourRange.MIN + (serviceHourRange.MAX ? ' - ' + serviceHourRange.MAX : ' +') + ' hour(s)';
                        } else {
                            this.formChanges['serviceHour'].CHANGED_VALUE = '';
                        }
                    } else {
                    }
                });

                this.updateDataSource();
            }
        });
        this.subs.push(formSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });

        clearTimeout(this.loadingSchoolEnrollmentsTimeout);
    }

    ngOnInit(): void {
        this.isLoading = true;

        // Use data IDs if exists
        if (this.data) {
            this.students = this.data.students;
            this.serviceDelivery = this.data.serviceDelivery;
            this.mode = this.data.mode;
            this.cosMode = this.data.cosMode;
        }

        // Reference API calls
        this.getCOSResons();
        this.getEnrollmentPeriods();

        // Needed
        this.getLatestCoeAndEligiblity(this.students);

        // School Enrollment API calls (if exists)
        if (this.mode === 'view') {
            this.title = 'Viewing Service Participation';
            this.form.disable();
        } else if (this.serviceDelivery) {
            this.title = 'Editing Service Participation';
        } else if (this.students.length > 1) {
            this.title = 'Adding Group Service Participations';
            this.displayedColumns = this.generateDisplayColumns();
        } else {
            this.title = 'Add a new Service Participation';
        }
        if (this.cosMode) {
            this.title += ' (COS)';
        }

        Promise.all(this.promises).then((res) => {
            setTimeout(() => {
                if (!this.serviceDelivery) {
                    this.getStudentEnrollmentsBySchoolDestrictScYrV2();
                }

                Promise.all(this.promises).then((res) => {
                    if (this.serviceDelivery) {
                        this.initEditServiceDelivery();
                    } else if (this.students.length > 1) {
                        this.initNewGroupServiceDelivery();
                    } else {
                        this.initNewServiceDelivery();
                    }
                });
            }, 1000);
            this.isLoading = false;
        });
    }

    generateDisplayColumns(prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
        let columns: any = this.columns;
        //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        const properties = Object.keys(columns);
        properties.forEach((property) => {
            if (columns[property].ENABLED) {
                displayedColumns.push(columns[property].SORT);
            }
        });

        return displayedColumns;
    }

    /*
     * API functions
     */
    getCOSResons() {
        let deferred = new Promise((resolve, reject) => {
            this.serviceDeliveryService.getCOSResons().subscribe((res) => {
                if (res.result) {
                    this.cosReasons = res.result;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getEnrollmentPeriods() {
        let deferred = new Promise((resolve, reject) => {
            this.serviceDeliveryService.getEnrollmentPeriods().subscribe((res) => {
                if (res.result) {
                    this.enrollmentPeriods = res.result.filter(
                        (ep: EnrollmentPeriods) => ep.PERIOD === 'Regular Year' || ep.PERIOD === 'Summer' || ep.PERIOD === 'Intersession'
                    );
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getLatestCoeAndEligiblity(students: Student[]) {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.getLatestCoeAndEligiblity(students).subscribe((res) => {
                if (res.students) {
                    this.missingEoEStudents = res.students;

                    this.setEligibilityAndTerminationRestrictions(this.missingEoEStudents);

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getStudentEnrollmentsBySchoolDestrictScYrV2() {
        if (this.students && this.students.length > 0 && this.selectedSchoolYear && this.chosenRegion?.CODE) {
            if (!this.loadingSchoolEnrollments) {
                this.loadingSchoolEnrollments = true;
                let deferred = new Promise((resolve, reject) => {
                    let studentsSchoolYears: any[] = [];
                    this.students.forEach((student) => {
                        studentsSchoolYears.push({
                            regionCode: this.chosenRegion?.CODE,
                            schoolYear: this.selectedSchoolYear,
                            studentID: student.ID
                        });
                    });

                    this.serviceDeliveryService.getStudentEnrollmentsBySchoolDestrictScYrV2(studentsSchoolYears).subscribe((res) => {
                        if (res.schoolEnrollmentsString) {
                            this.schoolEnrollments = res.schoolEnrollmentsString;

                            this.schoolEnrollments.forEach((se) => {
                                if (se.EnrollmentDate) {
                                    se.EnrollmentDate = this.cleanDatePipe.transform(se.EnrollmentDate);
                                }
                                if (se.WithdrawalDate) {
                                    se.WithdrawalDate = this.cleanDatePipe.transform(se.WithdrawalDate);
                                }
                            });

                            this.loadingSchoolEnrollments = false;

                            resolve(res);
                        } else if (res?.msg) {
                            this.schoolEnrollments = [];
                            this.loadingSchoolEnrollments = false;
                            resolve(res);
                        } else {
                            this.schoolEnrollments = [];
                            this.loadingSchoolEnrollments = false;
                            reject('err');
                        }
                    });
                });

                this.promises.push(deferred);
            }
        }
    }

    /*
     * SUBMIT functions
     */
    submit() {
        if (this.checkValid()) {
            this.isSubmitting = true;
            this.msg = new MsgModel();

            let payload = this.generatePayload();

            if (this.serviceDelivery) {
                this.serviceDeliveryService.editServiceDelivery(payload.serviceDelivery, payload.editedFields).subscribe({
                    next: (res) => {
                        if (res.msg) {
                            if (res.msg.SUCCESS) {
                                this.msg = res.msg;

                                this.msg.MSG += ' (closing modal in 3 seconds...)';
                                setTimeout(() => {
                                    this.dialogRef.close({ refresh: true });
                                }, 3000);
                            } else {
                                this.msg = res.msg;
                            }
                        } else {
                            this.msg = { MSG: 'There was an error updating service participations', SUCCESS: false };
                        }
                    },
                    error: (err) => {
                        if (err.msg) {
                            this.msg = err.msg;
                        } else {
                            this.msg = { MSG: 'Server error.', SUCCESS: false };
                        }
                    },
                    complete: () => {
                        this.isSubmitting = false;
                    }
                });
            } else {
                this.serviceDeliveryService.createServiceDelivery(payload.serviceDelivery, payload.serviceHourRanges, payload.students).subscribe({
                    next: (res) => {
                        if (res.msg) {
                            if (res.msg.SUCCESS) {
                                this.msg = res.msg;

                                this.msg.MSG += ' (closing modal in 3 seconds...)';
                                setTimeout(() => {
                                    this.dialogRef.close({ refresh: true });
                                }, 3000);
                            } else {
                                this.msg = res.msg;
                            }
                        } else {
                            this.msg = { MSG: 'There was an error creating service participations', SUCCESS: false };
                        }
                    },
                    error: (err) => {
                        if (err.msg) {
                            this.msg = err.msg;
                        } else {
                            this.msg = { MSG: 'Server error.', SUCCESS: false };
                        }
                    },
                    complete: () => {
                        this.isSubmitting = false;
                    }
                });
            }
        }
    }

    checkValid() {
        this.form.markAllAsTouched();
        let valid = true;
        if (!this.hasAtLeastOneStudent()) {
            this.msg = { MSG: 'Please select at least one child.', SUCCESS: false };
            valid = false;
        } else if (this.creationFlags.length > 0) {
            this.msg = { MSG: 'A child is ineligible for the selected school year.', SUCCESS: false };
            valid = false;
        } else if (!this.chosenRegion?.ID) {
            this.msg = { MSG: 'Please select a Region', SUCCESS: false };
            valid = false;
        } else if (!this.chosenCounty?.ID) {
            this.msg = { MSG: 'Please select a County', SUCCESS: false };
            valid = false;
        } else if (!this.chosenSchoolDistrict?.ID) {
            this.msg = { MSG: 'Please select a School District', SUCCESS: false };
            valid = false;
        } else if (!this.chosenSchool?.ID) {
            this.msg = { MSG: 'Please select a School', SUCCESS: false };
            valid = false;
        } else if (!this.selectedSchoolYear) {
            this.msg = { MSG: 'Please select a School Year', SUCCESS: false };
            valid = false;
        } else if (!this.chosenServices || (this.chosenServices && this.chosenServices.length === 0)) {
            this.msg = { MSG: 'Please select a service', SUCCESS: false };
            valid = false;
        } else if (this.form.invalid) {
            this.msg = { MSG: 'Please input required fields', SUCCESS: false };
            valid = false;
        }

        setTimeout(() => {
            this.msg = undefined!;
        }, 7000);

        return valid;
    }

    // Payload generation
    generatePayload() {
        let payload: any = {};

        // .students
        let uniqueStudents: any[];

        if (this.students.length > 1) {
            uniqueStudents = this.resolveOnlyChosenStudents();
        } else {
            uniqueStudents = this.students.filter((student, index, self) => index === self.findIndex((s) => s.ID === student.ID));
        }

        if (this.students.length > 1) {
            payload.students = JSON.parse(
                JSON.stringify(
                    uniqueStudents.map((student: any) => {
                        let grade = this.getGradeByNamePipe.transform(student.SCHOOL_ENROLLMENT_DETAILS![0].GRADE);
                        return {
                            ID: student.ID,
                            GRADES_ID: grade ? grade.ID : 0
                        };
                    })
                )
            );
        } else {
            payload.students = JSON.parse(
                JSON.stringify(
                    uniqueStudents.map((student: any) => {
                        return {
                            ID: student.ID,
                            GRADES_ID: this.chosenGrade.ID
                        };
                    })
                )
            );
        }

        // .serviceDelivery
        let serviceDelivery: ServiceDeliveries = new ServiceDeliveries();

        if (this.serviceDelivery) {
            serviceDelivery.ID = this.serviceDelivery.ID;
            // student
            serviceDelivery.STUDENTS_ID = this.students[0].ID!;
            // chosen service
            serviceDelivery.PARTY_SERVICES_ID = this.chosenServices[0].ID!;
            // service hour
            serviceDelivery.SERVICE_HOUR_RANGES_ID = this.form.get(serviceDelivery.PARTY_SERVICES_ID!.toString())?.value.ID;
            // grade
            serviceDelivery.GRADES_ID = this.chosenGrade.ID!;
        }
        serviceDelivery.SCHOOL_YEAR = this.selectedSchoolYear;
        serviceDelivery.START_DATE = this.form.get('startDate')?.value;
        if (this.form.get('endDate')?.value) {
            serviceDelivery.END_DATE = this.form.get('endDate')?.value;
        }
        serviceDelivery.PARTY_ROLES_ID = this.chosenSchool.ORGANIZATION.PARTy.PARTY_ROLES[0].ID;
        serviceDelivery.ENROLLMENT_PERIODS_ID = this.chosenEnrollmentPeriods[0].ID!;
        let uniquiePartyServices = this.chosenServices.filter((cs, index, self) => index === self.findIndex((s) => s.ID === cs.ID));
        serviceDelivery.PARTY_SERVICES_IDs = uniquiePartyServices.map((cs) => {
            return cs.ID!;
        });
        if (this.cosMode && this.form.get('cosType')?.value) {
            serviceDelivery.COS_REASONS_ID = this.form.get('cosType')?.value.ID;
        }

        payload.serviceDelivery = serviceDelivery;

        // .serviceHourRanges [for adding]
        let serviceHourRanges: any = [];
        this.chosenServiceHoursRequired.forEach((s) => {
            let serviceHourRange: any = {};
            serviceHourRange.PARTY_SERVICES_ID = s.ID;
            serviceHourRange.SERVICE_HOUR_RANGES_ID = this.form.get(s.ID!.toString())?.value.ID;

            serviceHourRanges.push(serviceHourRange);
        });
        if (serviceHourRanges && serviceHourRanges.length > 0) {
            payload.serviceHourRanges = serviceHourRanges;
        }

        // Edit History
        if (serviceDelivery) {
            payload.editedFields = this.generateEditedFields();
        }

        return payload;
    }

    generateEditedFields() {
        if (this.tableDataSource.filteredData) {
            if (this.tableDataSource.filteredData.length > 0) {
                let editedFields: any[] = [];

                this.tableDataSource.filteredData.forEach((data) => {
                    editedFields.push({
                        CHANGED_FIELD: data.CHANGED_FIELD,
                        CHANGED_VALUE: data.VALUE
                    });
                });

                return editedFields;
            } else {
                return;
            }
        } else {
            return;
        }
    }

    initNewServiceDelivery() {
        this.restrictedDateOptions.minDate = undefined!;
        this.restrictedDateOptions.maxDate = undefined!;

        setTimeout(() => {
            this.students.forEach((s) => {
                s.ENABLED = true;
            });

            this.buildUniqueStudents();
        });
    }

    initEditServiceDelivery() {
        // Adjust required fields
        this.form.get('schoolEnrollment')?.setValidators(null);
        this.form.get('schoolEnrollment')?.updateValueAndValidity();

        // School Year
        this.selectSchoolYear = this.serviceDelivery.SCHOOL_YEAR;

        // Service
        this.selectServices = [this.serviceDelivery.PARTY_SERVICES];

        // Location
        setTimeout(() => {
            this.chosenRegion = this.serviceDelivery.REGION;
            this.chosenCounty = this.serviceDelivery.COUNTY;
            this.chosenCountyName = this.chosenCounty ? this.chosenCounty.COUNTY_NAME! : '';
            this.chosenSchoolDistrict = this.serviceDelivery.SCHOOL_DISTRICTS;
            this.chosenSchoolDistrictName = this.chosenSchoolDistrict ? this.chosenSchoolDistrict.DISTRICTS! : '';
            this.chosenSchool = this.serviceDelivery.SCHOOL;
            this.chosenSchoolName = this.chosenSchool ? this.chosenSchool.NAME! : '';
        }, 500);

        // Grade
        let chosenGrade: Grade = new Grade();
        chosenGrade.GRADES = this.serviceDelivery.GRADES;
        this.chosenGrades = [chosenGrade];
        this.chosenGrade = chosenGrade;

        // Enrollment Period
        let enrollmentPeriod = this.enrollmentPeriods.find((ep) => ep.ID === this.serviceDelivery.ENROLLMENT_PERIODS_ID);
        if (enrollmentPeriod) {
            this.form.get('enrollmentType')?.patchValue(enrollmentPeriod?.PERIOD);
            this.form.get('enrollmentType')?.disable();
            this.chosenEnrollmentPeriods = [enrollmentPeriod]; // this will force search Services dropdown
        }

        // Start Date
        this.form.get('startDate')?.patchValue(this.serviceDelivery.START_DATE);

        // End Date
        this.form.get('endDate')?.patchValue(this.serviceDelivery.END_DATE);

        // COS
        if (this.cosMode) {
            let cosReason = this.cosReasons.find((cr) => cr.ID === this.serviceDelivery.COS_REASONS_ID);
            if (cosReason) {
                this.form.get('cosType')?.patchValue(cosReason);
            }
        }

        // Try to find School Enrollment
        setTimeout(() => {
            this.getStudentEnrollmentsBySchoolDestrictScYrV2();
            Promise.all(this.promises).then((res) => {
                this.checkGradeAndType();
            });
        }, 1000);

        // Set form (End Date will be required on edit)
        this.form.get('endDate')?.setValidators([Validators.required]);
        this.form.get('endDate')?.updateValueAndValidity();

        setTimeout(() => {
            this.students.forEach((s) => {
                s.ENABLED = true;
            });

            this.buildUniqueStudents();
        });

        // Init backup history
        this.loadingChanges = true;
        this.initCurrentChanges();

        this.waitForSchoolEnrollmentToSetChanges();
    }

    initNewGroupServiceDelivery() {
        this.isLoadingGroup = true;
        this.restrictedDateOptions.minDate = undefined!;
        this.restrictedDateOptions.maxDate = undefined!;

        // Adjust required fields
        this.form.get('schoolEnrollment')?.setValidators(null);
        this.form.get('schoolEnrollment')?.updateValueAndValidity();
        this.form.get('schoolYear')?.setValidators(null);
        this.form.get('schoolYear')?.updateValueAndValidity();

        // School Year
        this.selectSchoolYear = this.getPropertyPipe.transform(this.students[0], 'SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR');

        // Location
        this.chosenRegion = this.getPropertyPipe.transform(this.students[0], 'REGION');
        this.chosenCounty = this.getPropertyPipe.transform(this.students[0], 'COUNTy');
        this.chosenCountyName = this.getPropertyPipe.transform(this.students[0], 'COUNTy.COUNTY_NAME', false, true);
        this.chosenSchoolDistrict = this.getPropertyPipe.transform(this.students[0], 'SCHOOL_DISTRICTS');
        this.chosenSchoolDistrictName = this.getPropertyPipe.transform(this.students[0], 'SCHOOL_DISTRICTS.ORGANIZATION.NAME', false, true);
        this.chosenSchool = this.getPropertyPipe.transform(this.students[0], 'SCHOOL');
        this.chosenSchoolName = this.getPropertyPipe.transform(this.students[0], 'SCHOOL.ORGANIZATION.NAME', false, true);

        // Try to find School Enrollment
        setTimeout(() => {
            Promise.all(this.promises).then((res) => {
                this.students.forEach((s) => {
                    s.ENABLED = true;
                });

                this.buildUniqueStudents();
                this.checkGradeAndType();

                this.updateSelectedChildrenDataSource();

                this.studentLength = this.resolveOnlyChosenStudents().length;
                this.isLoadingGroup = false;
            });
        }, 1000);
    }

    waitForSchoolEnrollmentToSetChanges() {
        if (this.chosenServices && this.chosenServices.length > 0 && (this.cosMode || this.chosenSchoolEnrollment)) {
            clearTimeout(this.loadingSchoolEnrollmentsTimeout);
            this.setCurrentChanges();
            this.updateDataSource();

            this.loadingChanges = false;
        } else {
            clearTimeout(this.loadingSchoolEnrollmentsTimeout);
            this.loadingSchoolEnrollmentsTimeout = setInterval(() => {
                this.waitForSchoolEnrollmentToSetChanges();
            }, 1000);
        }
    }

    checkGradeAndType(chosenSchoolEnrollment?: any) {
        if (chosenSchoolEnrollment) {
        } else if (this.serviceDelivery) {
            // Filter School Enrollments by chosen School District
            let schoolEnrollments = this.schoolEnrollments.filter(
                (se) => se.SCHOOL_DISTRICT.ID === this.chosenSchoolDistrict.ID && se.Grade === this.serviceDelivery.GRADES
            );

            if (schoolEnrollments && schoolEnrollments.length > 0) {
                this.chosenSchoolEnrollment = schoolEnrollments[0];
            }
        }

        this.restrictDates();
        this.setDates();
    }

    // Dialog function
    closeDialog(closed: boolean) {
        if (this.mode === 'view') {
            this.dialogRef.close();
        } else {
            Swal.fire({
                titleText: 'Are you sure you want to continue without saving?',
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Go Back',
                icon: 'warning',
                confirmButtonColor: '#3a6b35'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    this.dialogRef.close();
                }
            });
        }
    }

    getCurrentYear(year: string) {
        return year.substring(0, 4);
    }

    getNextYear(year: string) {
        var next = parseInt(year.substring(0, 4));
        next = next + 1;
        return next.toString();
    }

    dateFilter = (date: Date | null) => {
        if (date) {
            //return date.getMonth() % 2 == 1 && date.getDate() % 2 == 0
            //return date.getMonth() === new Date().getMonth() && date.getDate() === new Date().getDate();
            return true;
        } else {
            return false;
        }
    };

    /**************************************************************************************************************************
     * Event Emitters
     **************************************************************************************************************************/
    regionEventEmitter(regions: Region[]) {
        this.chosenRegion = regions ? regions[0] : new Region();
    }

    countiesEventEmitter(counties: County[]) {
        this.chosenCounty = counties ? counties[0] : new County();

        if (this.cosMode && this.formChanges['county']) {
            this.formChanges['county'].CHANGED_VALUE = this.chosenCounty;
            this.updateDataSource();
        }
    }

    districtsEventEmitter(districts: SchoolDistrict[]) {
        this.chosenSchoolDistrict = districts ? districts[0] : new SchoolDistrict();

        if (this.cosMode && this.formChanges['schoolDistrict']) {
            this.formChanges['schoolDistrict'].CHANGED_VALUE = this.chosenSchoolDistrict;
            this.updateDataSource();
        }
    }

    schoolsEventEmitter(schools: School[]) {
        this.chosenSchool = schools ? schools[0] : new School();

        if (this.cosMode && this.formChanges['school']) {
            this.formChanges['school'].CHANGED_VALUE = this.chosenSchool;
            this.updateDataSource();
        }
    }

    gradeEventEmitter(grades: Grade[]) {
        if (grades) {
            if (Array.isArray(grades)) {
                this.chosenGrade = grades[0];
            } else {
                this.chosenGrade = grades;
            }

            if (this.cosMode && this.formChanges['grade']) {
                this.formChanges['grade'].CHANGED_VALUE = this.chosenGrade;
                this.updateDataSource();
            }
        }
    }

    schoolYearEvent(schoolYear: string) {
        this.selectedSchoolYear = schoolYear;

        this.setDates();

        this.getStudentEnrollmentsBySchoolDestrictScYrV2();
    }

    enrollmentPeriodChange(event: any) {
        let chosenEnrollmentPeriod = this.enrollmentPeriods.find((ep) => ep.PERIOD === event.value);

        if (chosenEnrollmentPeriod) {
            this.chosenEnrollmentPeriods = [chosenEnrollmentPeriod!];
        }

        this.restrictDates();
        this.setDates();
        this.updateDataSource();
    }

    schoolEnrollmentChange(event: any) {
        this.chosenSchoolEnrollment = event.value;

        this.chosenCounty = this.chosenSchoolEnrollment.COUNTY;
        this.chosenCountyName = this.chosenSchoolEnrollment.COUNTY.COUNTY_NAME;

        this.chosenSchoolDistrict = this.chosenSchoolEnrollment.SCHOOL_DISTRICT;
        this.chosenSchoolDistrictName = this.chosenSchoolEnrollment.SCHOOL_DISTRICT.DISTRICTS;

        this.chosenSchool = this.chosenSchoolEnrollment.SCHOOL;
        this.chosenSchoolName = this.chosenSchoolEnrollment.SCHOOL.ORGANIZATION.NAME;

        let chosenGrade: Grade = new Grade();
        chosenGrade.GRADES = this.chosenSchoolEnrollment.Grade;
        this.chosenGrades = [chosenGrade];

        this.restrictDates();
        this.setDates();
    }

    cosChange(event: any) {}

    serviceEventEmitter(event: any) {
        if (Array.isArray(event)) {
            this.chosenServices = event;
        } else {
            this.chosenServices = [event];
        }

        if (this.chosenServiceHoursRequired) {
            this.chosenServiceHoursRequired.forEach((shr) => this.removeControl(shr.ID!.toString()));
        }
        this.chosenServiceHoursRequired = this.chosenServices.filter((s) => s.SERVICE_HOURS?.NAME === 'Yes');
        if (this.chosenServiceHoursRequired) {
            this.chosenServiceHoursRequired.forEach((shr) => {
                this.addControl(shr.ID!.toString());

                if (this.serviceDelivery && this.serviceDelivery.SERVICE_HOUR_RANGES && this.serviceDelivery.SERVICE_HOUR_RANGES.ID) {
                    if (this.serviceDelivery.PARTY_SERVICES_ID === shr.ID) {
                        let foundServiceHourRange = shr.MEASURABLE_PROGRAM_OBJECTIVES?.SERVICE_HOUR_RANGES?.find(
                            (range) => range.ID === this.serviceDelivery.SERVICE_HOUR_RANGES.ID
                        );
                        this.form.get(shr.ID!.toString())?.patchValue(foundServiceHourRange);
                    }
                }
            });
        }

        // set tracking history
        if (this.serviceDelivery && this.chosenServices && this.chosenServices.length > 0) {
            this.formChanges['serviceName'].CHANGED_VALUE = this.chosenServices[0].SERVICE_NAME;
            let serviceHourRange: ServiceHourRanges = this.form.get(this.chosenServices[0].ID!.toString())?.value;
            if (serviceHourRange) {
                this.formChanges['serviceHour'].CHANGED_VALUE =
                    serviceHourRange.MIN + (serviceHourRange.MAX ? ' - ' + serviceHourRange.MAX : ' +') + ' hour(s)';
            } else {
                this.formChanges['serviceHour'].CHANGED_VALUE = '';
            }
            this.updateDataSource();
        }
    }

    addControl(name: string): void {
        this.form.addControl(name, new UntypedFormControl());

        if (this.mode === 'view') {
            this.form.get(name)?.disable();
        } else {
            this.form.get(name)?.addValidators([Validators.required]);
            this.form.get(name)?.updateValueAndValidity();
        }
    }

    removeControl(name: string): void {
        this.form.removeControl(name);
        this.form.updateValueAndValidity();
    }

    /**************************************************************************************************************************
     * Date Filters
     **************************************************************************************************************************/
    restrictDates() {
        let allSchoolEnrollments: any[] = this.combineSchoolEnrollments();
        this.restrictedDateOptions.minDate = undefined!;
        this.restrictedDateOptions.maxDate = undefined!;
        this.ageRestrictedStudent = undefined;

        // allSchoolEnrollments.push({
        //     ENROLLMENT_DATE: new Date('2023-08-10'),
        //     WITHDRAWAL_DATE: new Date('2023-09-10')
        // });

        allSchoolEnrollments.forEach((se) => {
            if (se.ENROLLMENT_DATE) {
                if (!this.restrictedDateOptions.minDate) {
                    this.restrictedDateOptions.minDate = se.ENROLLMENT_DATE;
                } else if (se.ENROLLMENT_DATE > this.restrictedDateOptions.minDate) {
                    this.restrictedDateOptions.minDate = se.ENROLLMENT_DATE;
                }
            }
            if (se.WITHDRAWAL_DATE) {
                if (!this.restrictedDateOptions.maxDate) {
                    this.restrictedDateOptions.maxDate = se.WITHDRAWAL_DATE;
                } else if (se.WITHDRAWAL_DATE < this.restrictedDateOptions.maxDate) {
                    this.restrictedDateOptions.maxDate = se.WITHDRAWAL_DATE;
                }
            }
        });

        if (this.form.get('enrollmentType')?.value === 'Summer' || this.form.get('enrollmentType')?.value === 'Intersession') {
            let ageRestrictedStudent: any;
            this.thirdBirthdayFlag = false;

            this.resolveOnlyChosenStudents().forEach((student: any) => {
                let birthday = new Date(student.DOB);
                const thirdBirthday = new Date(birthday);
                thirdBirthday.setFullYear(thirdBirthday.getFullYear() + 3);

                if (!this.restrictedDateOptions.minDate) {
                    this.restrictedDateOptions.minDate = thirdBirthday;
                    ageRestrictedStudent = student;
                } else if (thirdBirthday > this.restrictedDateOptions.minDate) {
                    this.restrictedDateOptions.minDate = thirdBirthday;
                    ageRestrictedStudent = student;
                }
            });

            if (ageRestrictedStudent) {
                this.thirdBirthdayFlag = true;
                this.ageRestrictedStudent = ageRestrictedStudent;
            }
        }
    }

    combineSchoolEnrollments() {
        let allSchoolEnrollments: any[] = [];

        // Add School Enrollment when chosen from drop-down
        if (this.chosenSchoolEnrollment) {
            let schoolEnrollmentDetails: SchoolEnrollmentDetailsAsl = new SchoolEnrollmentDetailsAsl();
            schoolEnrollmentDetails.ID = this.chosenSchoolEnrollment.SchoolEnrollID;
            schoolEnrollmentDetails.ENROLLMENT_DATE = this.chosenSchoolEnrollment.EnrollmentDate;
            schoolEnrollmentDetails.WITHDRAWAL_DATE = this.chosenSchoolEnrollment.WithdrawalDate;

            allSchoolEnrollments.push(schoolEnrollmentDetails);
        }

        // Add School Enrollments from students (from Group Services)
        if (this.students.length > 1) {
            this.resolveOnlyChosenStudents().forEach((s: any) => {
                if (s.SCHOOL_ENROLLMENT_DETAILS) {
                    let schoolEnrollmentDetails: SchoolEnrollmentDetailsAsl = new SchoolEnrollmentDetailsAsl();
                    schoolEnrollmentDetails.ID = s.SCHOOL_ENROLLMENT_DETAILS[0].ID;
                    schoolEnrollmentDetails.ENROLLMENT_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE);
                    schoolEnrollmentDetails.WITHDRAWAL_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE);

                    allSchoolEnrollments.push(schoolEnrollmentDetails);
                }
            });
        } else if (this.students && this.students.length > 0) {
            this.students.forEach((s) => {
                if (s.SCHOOL_ENROLLMENT_DETAILS) {
                    let schoolEnrollmentDetails: SchoolEnrollmentDetailsAsl = new SchoolEnrollmentDetailsAsl();
                    schoolEnrollmentDetails.ID = s.SCHOOL_ENROLLMENT_DETAILS[0].ID;
                    schoolEnrollmentDetails.ENROLLMENT_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE);
                    schoolEnrollmentDetails.WITHDRAWAL_DATE = this.cleanDatePipe.transform(s.SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE);

                    allSchoolEnrollments.push(schoolEnrollmentDetails);
                }
            });
        }

        return allSchoolEnrollments;
    }

    setEligibilityAndTerminationRestrictions(students: Student[]) {
        this.maxEndOfEligibilityStudent = undefined;
        this.maxTerminationStudent = undefined;

        students.forEach((student) => {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );

            if (eoeDate) {
                if (!this.maxEndOfEligibilityStudent) {
                    this.maxEndOfEligibilityStudent = student;
                } else {
                    let currentEoE = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(
                            this.maxEndOfEligibilityStudent,
                            'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                        )
                    );

                    if (new Date(eoeDate) < new Date(currentEoE)) {
                        this.maxEndOfEligibilityStudent = student;
                    }
                }
            }

            let terminationID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].ID');
            let terminationDate = this.cleanDatePipe.transform(this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE'));
            let terminationTypeID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID');

            if (terminationID) {
                if (!this.maxTerminationStudent && terminationTypeID !== 1) {
                    this.maxTerminationStudent = student;
                } else {
                    let currentTerminationDate = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                    );

                    if (new Date(terminationDate) < new Date(currentTerminationDate) && terminationTypeID !== 1) {
                        this.maxTerminationStudent = student;
                    }
                }
            }
        });
    }

    setDates() {
        this.dateFlags = [];
        this.creationFlags = [];

        this.setStartDates();
        this.setEndDate();
    }

    setStartDates() {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date;
        let maxDate: Date;

        if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'R') {
            this.startDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                    minDate = this.restrictedDateOptions.minDate;
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }
            } else {
                minDate = new Date(currentYear, 6, 1);
            }
            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate < new Date(nextYear, 7, 31)) {
                    maxDate = this.restrictedDateOptions.maxDate;
                } else {
                    maxDate = new Date(nextYear, 7, 31);
                }
            } else {
                maxDate = new Date(nextYear, 7, 31);
            }
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'S') {
            this.startDateOptions.defaultMinDate = new Date(nextYear, 4, 15);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate > new Date(nextYear, 4, 15)) {
                    minDate = this.restrictedDateOptions.maxDate;
                } else {
                    minDate = new Date(nextYear, 4, 15);
                }
            } else {
                minDate = new Date(nextYear, 4, 15);
            }
            // This is for a child's third birthday
            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > minDate) {
                    minDate = this.restrictedDateOptions.minDate;
                }
            }
            maxDate = new Date(nextYear, 7, 31);
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'I') {
            this.startDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                    minDate = this.restrictedDateOptions.minDate;
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }
            } else {
                minDate = new Date(currentYear, 6, 1);
            }
            maxDate = new Date(nextYear, 7, 31);
        } else {
            this.startDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.startDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);
            minDate = new Date(currentYear, 6, 1);
            maxDate = new Date(nextYear, 7, 31);
        }

        if (this.cosMode) {
            if (this.maxEndOfEligibilityStudent) {
                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        this.maxEndOfEligibilityStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );
                if (minDate <= eoeDate) {
                    minDate = new Date(eoeDate);
                    minDate.setDate(minDate.getDate() + 1);
                }
            }
        } else {
            if (this.maxEndOfEligibilityStudent && this.maxTerminationStudent) {
                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        this.maxEndOfEligibilityStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );
                let terminationDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                );

                if (eoeDate <= terminationDate) {
                    if (eoeDate < maxDate) {
                        let studentName = this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                            ? this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                            : this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.FIRST_NAME') +
                              ' ' +
                              this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.LAST_NAME');
                        let msdNumber = this.maxEndOfEligibilityStudent.MSD_NUMBER;
                        maxDate = eoeDate;

                        this.dateFlags.push({
                            MIN_MAX: 'Maximum',
                            DATE_TYPE: 'Start Date',
                            TYPE: 'End of Eligibility',
                            DATE: eoeDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });

                        if (eoeDate < minDate) {
                            this.creationFlags.push({
                                TYPE: 'End of Eligibility',
                                DATE: eoeDate,
                                NAME: studentName,
                                MSD_NUMBER: msdNumber
                            });
                        }
                    }
                } else {
                    if (terminationDate < maxDate) {
                        let studentName = this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                            ? this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                            : this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.FIRST_NAME') +
                              ' ' +
                              this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.LAST_NAME');
                        let msdNumber = this.maxTerminationStudent.MSD_NUMBER;
                        maxDate = terminationDate;

                        this.dateFlags.push({
                            MIN_MAX: 'Maximum',
                            DATE_TYPE: 'Start Date',
                            TYPE: 'Termination',
                            DATE: terminationDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });

                        if (terminationDate < minDate) {
                            this.creationFlags.push({
                                TYPE: 'Termination',
                                DATE: terminationDate,
                                NAME: studentName,
                                MSD_NUMBER: msdNumber
                            });
                        }
                    }
                }
            } else if (this.maxEndOfEligibilityStudent) {
                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        this.maxEndOfEligibilityStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );
                if (eoeDate < maxDate) {
                    let studentName = this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                        ? this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'NAME')
                        : this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.FIRST_NAME') +
                          ' ' +
                          this.getPropertyPipe.transform(this.maxEndOfEligibilityStudent, 'PERSON.LAST_NAME');
                    let msdNumber = this.maxEndOfEligibilityStudent.MSD_NUMBER;
                    maxDate = eoeDate;

                    this.dateFlags.push({
                        MIN_MAX: 'Maximum',
                        DATE_TYPE: 'Start Date',
                        TYPE: 'End of Eligibility',
                        DATE: eoeDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });

                    if (eoeDate < minDate) {
                        this.creationFlags.push({
                            TYPE: 'End of Eligibility',
                            DATE: eoeDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });
                    }
                }
            } else if (this.maxTerminationStudent) {
                let terminationDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                );
                if (terminationDate < maxDate) {
                    let studentName = this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                        ? this.getPropertyPipe.transform(this.maxTerminationStudent, 'NAME')
                        : this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.FIRST_NAME') +
                          ' ' +
                          this.getPropertyPipe.transform(this.maxTerminationStudent, 'PERSON.LAST_NAME');
                    let msdNumber = this.maxTerminationStudent.MSD_NUMBER;
                    maxDate = terminationDate;

                    this.dateFlags.push({
                        MIN_MAX: 'Maximum',
                        DATE_TYPE: 'Start Date',
                        TYPE: 'Termination',
                        DATE: terminationDate,
                        NAME: studentName,
                        MSD_NUMBER: msdNumber
                    });

                    if (terminationDate < minDate) {
                        this.creationFlags.push({
                            TYPE: 'Termination',
                            DATE: terminationDate,
                            NAME: studentName,
                            MSD_NUMBER: msdNumber
                        });
                    }
                }
            }
        }

        // No future dates
        let today = new Date();
        if (today < minDate) {
            minDate = new Date(this.startDateOptions.defaultMinDate);
            minDate.setDate(minDate.getDate() + 1);
            maxDate = new Date(this.startDateOptions.defaultMinDate);
        } else if (maxDate > new Date()) {
            maxDate = new Date();
        }

        this.startDateOptions.minDate = minDate;
        this.startDateOptions.maxDate = maxDate;
        this.startDateOptions.startAt = minDate;
    }

    setEndDate(startDate?: Date) {
        let currentYear: number = parseInt(this.selectedSchoolYear.substring(0, 4));
        let nextYear: number = currentYear + 1;
        let minDate: Date;
        let maxDate: Date;

        if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'R') {
            this.endDateOptions.defaultMinDate = new Date(nextYear, 6, 1);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);

            if (this.restrictedDateOptions.minDate) {
                if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                    minDate = this.restrictedDateOptions.minDate;
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }
            } else {
                minDate = new Date(currentYear, 6, 1);
            }
            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate < new Date(nextYear, 7, 31)) {
                    maxDate = this.restrictedDateOptions.maxDate;
                } else {
                    maxDate = new Date(nextYear, 7, 31);
                }
            } else {
                maxDate = new Date(nextYear, 7, 31);
            }
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'S') {
            this.endDateOptions.defaultMinDate = new Date(currentYear, 4, 15);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 8, 20);

            if (this.restrictedDateOptions.maxDate) {
                if (this.restrictedDateOptions.maxDate > new Date(nextYear, 4, 15)) {
                    minDate = this.restrictedDateOptions.maxDate;
                } else {
                    minDate = new Date(nextYear, 4, 15);
                }
            } else {
                minDate = new Date(nextYear, 4, 15);
            }
            maxDate = new Date(nextYear, 8, 20);
        } else if (this.chosenEnrollmentPeriods && this.chosenEnrollmentPeriods.length > 0 && this.chosenEnrollmentPeriods[0].CODE === 'I') {
            this.endDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);
            this.endDateOptions.defaultMaxDate.setDate(this.startDateOptions.defaultMaxDate.getDate() + 30);

            if (startDate) {
                minDate = startDate;
                maxDate = new Date(startDate);
                maxDate.setDate(startDate.getDate() + 30);
            } else {
                if (this.restrictedDateOptions.minDate) {
                    if (this.restrictedDateOptions.minDate > new Date(currentYear, 6, 1)) {
                        minDate = this.restrictedDateOptions.minDate;
                    } else {
                        minDate = new Date(currentYear, 6, 1);
                    }
                } else {
                    minDate = new Date(currentYear, 6, 1);
                }

                if (this.restrictedDateOptions.maxDate) {
                    if (this.restrictedDateOptions.maxDate < new Date(nextYear, 7, 31)) {
                        maxDate = this.restrictedDateOptions.maxDate;
                    } else {
                        maxDate = new Date(nextYear, 7, 31);
                        maxDate.setDate(maxDate.getDate() + 30);
                    }
                } else {
                    maxDate = new Date(nextYear, 7, 31);
                    maxDate.setDate(maxDate.getDate() + 30);
                }
            }
        } else {
            this.endDateOptions.defaultMinDate = new Date(currentYear, 6, 1);
            this.endDateOptions.defaultMaxDate = new Date(nextYear, 7, 31);
            minDate = new Date(currentYear, 6, 1);
            maxDate = new Date(nextYear, 7, 31);
        }

        if (this.cosMode) {
            if (this.maxEndOfEligibilityStudent) {
                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        this.maxEndOfEligibilityStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );
                if (minDate <= eoeDate) {
                    minDate = new Date(eoeDate);
                    minDate.setDate(minDate.getDate() + 1);
                }
            }
        } else {
            if (this.maxEndOfEligibilityStudent && this.maxTerminationStudent) {
                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        this.maxEndOfEligibilityStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );
                let terminationDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                );

                if (eoeDate <= terminationDate) {
                    if (eoeDate < maxDate) {
                        maxDate = eoeDate;
                    }
                } else {
                    if (terminationDate < maxDate) {
                        maxDate = terminationDate;
                    }
                }
            } else if (this.maxEndOfEligibilityStudent) {
                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        this.maxEndOfEligibilityStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );
                if (eoeDate < maxDate) {
                    maxDate = eoeDate;
                }
            } else if (this.maxTerminationStudent) {
                let terminationDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                );
                if (terminationDate < maxDate) {
                    maxDate = terminationDate;
                }
            }
        }

        if (startDate && minDate < startDate) {
            minDate = startDate;
        }

        let today = new Date();
        if (today < minDate) {
            minDate = new Date(this.endDateOptions.defaultMinDate);
            minDate.setDate(minDate.getDate() + 1);
            maxDate = new Date(this.endDateOptions.defaultMinDate);
        } else if (maxDate > new Date()) {
            maxDate = new Date();
        }

        this.endDateOptions.minDate = minDate;
        this.endDateOptions.maxDate = maxDate;
        this.endDateOptions.startAt = minDate;
    }

    /**************************************************************************************************************************
     * Confirmation pop-up for adding
     **************************************************************************************************************************/
    confirmPopup() {
        this.msg = new MsgModel();
        if (this.checkValid()) {
            if (this.chosenSchoolEnrollment || this.cosMode) {
                var text =
                    '<h3>These Services will be added to ' +
                    this.getCheckStudentsLength(this.students) +
                    ' child(ren)</h3><br/>' +
                    '<div class="row">' +
                    '<div>' +
                    '<label>Start Date: &nbsp;</label>' +
                    this.simpleDatePipe.transform(this.form.get('startDate')!.value) +
                    '</div>' +
                    '<div>' +
                    '<label>End Date: &nbsp;</label>' +
                    (this.simpleDatePipe.transform(this.form.get('endDate')!.value) ? this.simpleDatePipe.transform(this.form.get('endDate')!.value) : '---') +
                    '</div>' +
                    '</div>' +
                    '<br/>' +
                    '<div align="left" style="font-weight:bold">' +
                    this.chosenServices.length.toString() +
                    ' Service(s):</div>';

                text += '<div class="scrollable-200 margin-horizontal-sm font-size-14">';
                this.chosenServices.forEach((service) => {
                    text += '<div align="left"><label><i class="fa fa-fw fa-check-square-o"></i>&nbsp;' + service.SERVICE_NAME + '</label></div>';

                    if (service.MEASURABLE_PROGRAM_OBJECTIVES && service.MEASURABLE_PROGRAM_OBJECTIVES.ID) {
                        text +=
                            '<div align="left">' +
                            '<ul class="leaders">' +
                            '<li>' +
                            '<span>' +
                            '&emsp;- ' +
                            service.MEASURABLE_PROGRAM_OBJECTIVES?.NAME +
                            '</span>' +
                            '<span>';
                        text += this.form.get(service.ID!.toString())
                            ? this.form.get(service.ID!.toString())?.value.MIN +
                              (this.form.get(service.ID!.toString())?.value.MAX ? '-' + this.form.get(service.ID!.toString())?.value.MAX : '+') +
                              ' hour(s)'
                            : '';
                        text += '</span>' + '</li>' + '</ul>' + '</div>';
                    }
                });
                text += '</div>';

                Swal.fire({
                    title: 'Service Confirmation',
                    html: text,
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#3a6b35',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.isConfirmed) {
                        return this.submit();
                    }
                });
            } else if (this.students.length > 0) {
                var text =
                    '<h3>These Services will be added to ' +
                    this.getCheckStudentsLength(this.students) +
                    ' child(ren)</h3><br/>' +
                    '<div class="row">' +
                    '<div>' +
                    '<label>Start Date: &nbsp;</label>' +
                    this.simpleDatePipe.transform(this.form.get('startDate')!.value) +
                    '</div>' +
                    '<div>' +
                    '<label>End Date: &nbsp;</label>' +
                    (this.simpleDatePipe.transform(this.form.get('endDate')!.value) ? this.simpleDatePipe.transform(this.form.get('endDate')!.value) : '---') +
                    '</div>' +
                    '</div>' +
                    '<br/>' +
                    '<div align="left" style="font-weight:bold">' +
                    this.chosenServices.length.toString() +
                    ' Service(s):</div>';

                text += '<div class="scrollable-200 margin-horizontal-sm font-size-14">';
                this.chosenServices.forEach((service) => {
                    text += '<div align="left"><label><i class="fa fa-fw fa-check-square-o"></i>&nbsp;' + service.SERVICE_NAME + '</label></div>';

                    if (service.MEASURABLE_PROGRAM_OBJECTIVES && service.MEASURABLE_PROGRAM_OBJECTIVES.ID) {
                        text +=
                            '<div align="left">' +
                            '<ul class="leaders">' +
                            '<li>' +
                            '<span>' +
                            '&emsp;- ' +
                            service.MEASURABLE_PROGRAM_OBJECTIVES?.NAME +
                            '</span>' +
                            '<span>';
                        text += this.form.get(service.ID!.toString())
                            ? this.form.get(service.ID!.toString())?.value.MIN +
                              (this.form.get(service.ID!.toString())?.value.MAX ? '-' + this.form.get(service.ID!.toString())?.value.MAX : '+') +
                              ' hour(s)'
                            : '';
                        text += '</span>' + '</li>' + '</ul>' + '</div>';
                    }
                });
                text += '</div>';

                Swal.fire({
                    title: 'Service Confirmation',
                    html: text,
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#3a6b35',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.isConfirmed) {
                        return this.submit();
                    }
                });
            } else {
                this.msg.SUCCESS = false;
                this.msg.MSG = 'Error adding service. Please try again.';

                this.isLoading = false;
            }
        } else {
            // this.msg.SUCCESS = false;
            // this.msg.MSG = 'Error, please check your inputs.';
            // this.isLoading = false;
        }
    }

    getCheckStudentsLength = function (students: Student[]) {
        let uniqueStudents = students.filter((student, index, self) => index === self.findIndex((s) => s.ID === student.ID));

        return uniqueStudents ? uniqueStudents.length : 0;
    };

    /**************************************************************************************************************************
     * Tracking History
     **************************************************************************************************************************/
    initCurrentChanges() {
        // Static Form Group
        this.formChanges['startDate'] = { CHANGED_FIELD: 'Start Date', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['endDate'] = { CHANGED_FIELD: 'End Date', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['enrollmentType'] = { CHANGED_FIELD: 'Service Period', VALUE: '', CHANGED_VALUE: '' };

        // Non-form changes
        this.formChanges['serviceName'] = { CHANGED_FIELD: 'Service Name', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['region'] = { CHANGED_FIELD: 'Region', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['county'] = { CHANGED_FIELD: 'County', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['schoolDistrict'] = { CHANGED_FIELD: 'School District', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['school'] = { CHANGED_FIELD: 'School', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['schoolYear'] = { CHANGED_FIELD: 'School Year', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['grade'] = { CHANGED_FIELD: 'Grade', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['serviceHour'] = { CHANGED_FIELD: 'Service Hour', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['cosType'] = { CHANGED_FIELD: 'COS Type', VALUE: '', CHANGED_VALUE: '' };
    }

    setCurrentChanges() {
        // Static Form Group
        this.formChanges['startDate'].VALUE = this.form.get('startDate')?.value;
        this.formChanges['endDate'].VALUE = this.form.get('endDate')?.value;
        this.formChanges['enrollmentType'].VALUE = this.form.get('enrollmentType')?.value;

        // Non-form changes
        this.formChanges['region'].VALUE = this.chosenRegion;
        this.formChanges['county'].VALUE = this.chosenCounty;
        this.formChanges['schoolDistrict'].VALUE = this.chosenSchoolDistrict;
        this.formChanges['school'].VALUE = this.chosenSchool;
        this.formChanges['schoolYear'].VALUE = this.selectedSchoolYear;
        this.formChanges['grade'].VALUE = this.chosenGrade;

        if (this.chosenServices && this.chosenServices.length > 0) {
            this.formChanges['serviceName'].VALUE = this.chosenServices[0].SERVICE_NAME;
            let serviceHourRange: ServiceHourRanges = this.form.get(this.chosenServices[0].ID!.toString())?.value;
            if (serviceHourRange) {
                this.formChanges['serviceHour'].VALUE = serviceHourRange.MIN + (serviceHourRange.MAX ? ' - ' + serviceHourRange.MAX : ' +') + ' hour(s)';
            } else {
                this.formChanges['serviceHour'].VALUE = '';
            }
        }

        if (this.cosMode) {
            this.formChanges['cosType'].VALUE = this.form.get('cosType')?.value;
        }

        // Set same value
        Object.keys(this.formChanges).forEach((key) => {
            this.formChanges[key].CHANGED_VALUE = this.formChanges[key].VALUE;
        });
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<any>();
            this.tableDataSource.data = this.generateCurrentChangesTable();

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                //const dataStr = JSON.stringify(data).toLowerCase();
                //return dataStr.indexOf(filter) != -1;
                return data.CHANGED;
            };

            // Will always run the filterPredicate when filter has a value in it
            this.tableDataSource.filter = 'changed_only';
        });
    }

    generateCurrentChangesTable() {
        let result: any[] = [];

        // Form Group
        Object.keys(this.formChanges).forEach((key) => {
            let CHANGED_FIELD = this.formChanges[key].CHANGED_FIELD;
            let VALUE = this.formChanges[key].VALUE;
            let CHANGED_VALUE = this.formChanges[key].CHANGED_VALUE;

            if (typeof VALUE === 'object' && !Array.isArray(VALUE) && VALUE !== null) {
                if (VALUE['NAME']) {
                    VALUE = VALUE['NAME'];
                }
                // County
                else if (VALUE['COUNTY_NAME']) {
                    VALUE = VALUE['COUNTY_NAME'];
                }
                // District
                else if (VALUE['DISTRICTS']) {
                    VALUE = VALUE['DISTRICTS'];
                }
                // Grade
                else if (VALUE['GRADES']) {
                    VALUE = VALUE['GRADES'];
                }
                // COS Type
                else if (VALUE['REASON']) {
                    VALUE = VALUE['REASON'];
                }
            }
            if (typeof CHANGED_VALUE === 'object' && !Array.isArray(CHANGED_VALUE) && CHANGED_VALUE !== null) {
                if (CHANGED_VALUE['NAME']) {
                    CHANGED_VALUE = CHANGED_VALUE['NAME'];
                }
                // County
                else if (CHANGED_VALUE['COUNTY_NAME']) {
                    CHANGED_VALUE = CHANGED_VALUE['COUNTY_NAME'];
                }
                // District
                else if (CHANGED_VALUE['DISTRICTS']) {
                    CHANGED_VALUE = CHANGED_VALUE['DISTRICTS'];
                }
                // Grade
                else if (CHANGED_VALUE['GRADES']) {
                    CHANGED_VALUE = CHANGED_VALUE['GRADES'];
                }
                // COS Type
                else if (CHANGED_VALUE['REASON']) {
                    CHANGED_VALUE = CHANGED_VALUE['REASON'];
                }
            }

            switch (CHANGED_FIELD) {
                case 'Start Date':
                case 'End Date':
                    let dateValue = this.simpleDatePipe.transform(VALUE);
                    let changedDateValue = this.simpleDatePipe.transform(CHANGED_VALUE);
                    if (dateValue !== changedDateValue) {
                        result.push({
                            CHANGED_FIELD: CHANGED_FIELD,
                            VALUE: dateValue,
                            CHANGED_VALUE: changedDateValue,
                            CHANGED: true
                        });
                    }
                    break;
                default:
                    result.push({
                        CHANGED_FIELD: CHANGED_FIELD,
                        VALUE: VALUE,
                        CHANGED_VALUE: CHANGED_VALUE,
                        CHANGED: VALUE !== CHANGED_VALUE
                    });
                    break;
            }
        });

        return result;
    }

    buildUniqueStudents() {
        this.uniqueStudents = this.resolveDuplicateStudents(this.students);
    }

    resolveDuplicateStudents(students: any[]) {
        let uniques = [...new Map(students.map((s) => [s['ID'], s])).values()];

        return uniques;
    }

    updateSelectedChildrenDataSource(newSort?: boolean) {
        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.students.filter((student, index, self) => index === self.findIndex((s) => s.ID === student.ID));

            // Paginator
            dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            if (newSort) {
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
            } else {
                dataSource.sort.sortChange.emit(this.sorts.toArray()[0]);
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.selectedChildrenTableDataSource = dataSource;
        }, 100);
    }

    setSelectedChildrenFilter() {
        this.selectedChildrenTableDataSource.filter = this.selectedChildrenFilter.trim().toLocaleLowerCase();
    }

    toggleAllStudents() {
        if (this.hasAtLeastOneStudent()) {
            this.students.forEach((student: any) => {
                student.ENABLED = false;
            });
        } else {
            this.students.forEach((student: any) => {
                student.ENABLED = true;
            });
        }

        this.studentLength = this.resolveOnlyChosenStudents().length;

        this.setEligibilityAndTerminationRestrictions(this.resolveOnlyChosenMissingEoEStudents());
        this.restrictDates();
        this.setDates();
    }

    toggleStudent(student: any) {
        if (!student.GRADUATED) {
            student.ENABLED = !student.ENABLED;
        }

        this.studentLength = this.resolveOnlyChosenStudents().length;

        this.setEligibilityAndTerminationRestrictions(this.resolveOnlyChosenMissingEoEStudents());
        this.restrictDates();
        this.setDates();
    }

    hasAtLeastOneStudent() {
        let found = false;

        found = this.students.find((student: any) => student.ENABLED);

        return !!found;
    }

    hasDifferentCounts() {
        return this.uniqueStudents.length !== this.resolveOnlyChosenStudents().length;
    }

    resolveOnlyChosenStudents() {
        let returnStudents = JSON.parse(JSON.stringify(this.uniqueStudents));

        returnStudents = returnStudents.filter((student: any) => {
            return student.ENABLED;
        });

        return returnStudents;
    }

    resolveOnlyChosenMissingEoEStudents() {
        let returnStudents = JSON.parse(JSON.stringify(this.uniqueStudents));

        returnStudents = returnStudents.filter((student: any) => {
            return student.ENABLED;
        });

        let mergedStudents = returnStudents.map((s: any) => {
            let missingEoEStudents = this.missingEoEStudents.find((eoeStudent) => eoeStudent.ID === s.ID);
            return { ...s, ...missingEoEStudents };
        });

        return mergedStudents;
    }
}
